import { sendSubscriptionToPushServer } from 'src/store/api/notificationsApi';

const isPushNotificationSupported = () => {
  return 'serviceWorker' in navigator && 'PushManager' in window;
};

const askUserPermission = async () => {
  return await Notification.requestPermission();
};

const getConsentGranted = () => {
  return Notification.permission === 'granted';
};

const getUserSubscription = async () => {
  const serviceWorker = await navigator.serviceWorker.ready;
  return await serviceWorker.pushManager.getSubscription();
};

const createNotificationSubscription = async pushServerPublicKey => {
  const serviceWorker = await navigator.serviceWorker.ready;

  try {
    return await serviceWorker.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: pushServerPublicKey
    });
  } catch (error) {
    console.error(error);
  }
};

export const initNotifications = async pushServerPublicKey => {
  // await sendSubscriptionToPushServer(await createNotificationSubscription(pushServerPublicKey));
  if (isPushNotificationSupported()) {
    if (!getConsentGranted()) await askUserPermission();
    if (getConsentGranted()) {
      if (!(await getUserSubscription())) {
        await sendSubscriptionToPushServer(
          await createNotificationSubscription(pushServerPublicKey)
        );
      }
    }
  }
};
